import axios from 'axios';
import {
  API_URL,
  INSPECTORS_COMPANIES,
  UPDATE_INSPECTOR_COMPANIES,
  SHOW_INSPECTOR_COMPANIES,
  DELETE_INSPECTOR_COMPANIES_PASS,
  CREATE_INSPECTOR_COMPANIES,
  RESTORE_INSPECTOR_COMPANIES,
  DELETE_INSPECTOR_PASS,
  ACCIDENT_INCIDENT_CHART_DATA,
  ACCIDENT_INCIDENT_CHART_BY_EVENT_DATA,
  GET_INSPECTION_BY_INSPECTOR_FINDING, ACCIDENT_INCIDENT_IMMEDIATE_CAUSE_CHART_DATA,
  ACCIDENT_INCIDENT_ROOT_CAUSE_CHART_DATA
} from './ConstantService';
import {UrlService} from "@/services/UrlService";
import {GlobalService} from "@/services/GlobalService";

export const AccidentIncidentDashboardService = {
  getAccidentIncidentChartData(params = {}) {
    return axios.get(ACCIDENT_INCIDENT_CHART_DATA, { params });
  },

  getAccidentIncidentImmediateCauseChartData(params = {}) {
    return axios.get(ACCIDENT_INCIDENT_IMMEDIATE_CAUSE_CHART_DATA, { params });
  },

  getAccidentIncidentRootCauseChartData(params = {}) {
    return axios.get(ACCIDENT_INCIDENT_ROOT_CAUSE_CHART_DATA, { params });
  },

  async accidentIncidentByEvent(params){
    var queryString=UrlService.setQueryString(params);
    return await axios({
      url:ACCIDENT_INCIDENT_CHART_BY_EVENT_DATA+queryString,
      method: 'GET',
    }).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET ACCIDENT INCIDENT BY EVENT')
      return false
    })
  },

  show(id) {
    return axios.get(SHOW_INSPECTOR_COMPANIES.replace('{id}', id));
  },

  create(data) {
    return axios.post(CREATE_INSPECTOR_COMPANIES, data);
  },

  update(id, data) {
    return axios.patch(UPDATE_INSPECTOR_COMPANIES.replace('{id}', id), data);
  },

  delete(id) {
    return axios.delete(DELETE_INSPECTOR_COMPANIES.replace('{id}', id));
  },

  deleteWithPassword(id, password) {
    return axios.post(DELETE_INSPECTOR_COMPANIES_PASS.replace('{id}', id), { password });
  },

  restore(id) {
    return axios.post(RESTORE_INSPECTOR_COMPANIES.replace('{id}', id));
  }
};
